export const TimePeriod = {
    Yearly: 'Yearly',
    Quarterly: 'Quarterly',
    Monthly: 'Monthly',
    Weekly: 'Weekly'
};

export const TimePeriods = [
    TimePeriod.Yearly,
    TimePeriod.Quarterly,
    TimePeriod.Monthly,
    TimePeriod.Weekly
];

export const TimePeriodsMap: { [key: string]: string } = {
    'Yearly': TimePeriod.Yearly,
    'Quarterly': TimePeriod.Quarterly,
    'Monthly': TimePeriod.Monthly,
    'Weekly': TimePeriod.Weekly
};
